










import { Component, Vue, Prop } from 'vue-property-decorator';

interface Promo {
  title: string;
  extraTitle: string;
  backgroundPictName: string;
  textColorHex: '#ffffff' | '#333333';
}

@Component({
  name: 'promo-preview',
})
export default class PromoPreview extends Vue {
  @Prop() story!:Promo;

  get themeStyle() {
    return {
      color: this.story.textColorHex,
      backgroundImage: `url(${this.story.backgroundPictName})`,
    };
  }
}
